import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListAutoresponders = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'autoresponders'],
    queryFn: () => connectService.listAutoresponders()
  });

  return { autoresponders: data?.data ?? [], isLoading, error, refetch };
};
